import {describeError} from '../utils/describeError';
import {HttpForbiddenError, HttpUnauthorizedError} from '../utils/httpClient';
import {Notice} from './notice';
import {Typography} from './text';

/** Shown when the app cannot establish who you are. There is no login page: Cloudflare Access signs people in with an emailed code. */
export const AccessScreen = ({error}: {error: unknown}) => {
    const refused = error instanceof HttpUnauthorizedError || error instanceof HttpForbiddenError;

    return (
        <div className="app app-access">
            <div className="app-access-inner">
                <section
                    className="bt-sticker"
                    aria-label={refused ? 'Access refused' : 'Application error'}
                >
                    <div className="access-panel">
                        <span className="bt-brand">
                            Stack<em>TheBallot</em>
                        </span>

                        <div>
                            <Typography.PageTitle>
                                {refused ? 'You do not have access' : 'Something went wrong'}
                            </Typography.PageTitle>
                            <Typography.SecondaryText>
                                {refused
                                    ? 'We could not accept the account you signed in with.'
                                    : "We couldn't work out who you are."}
                            </Typography.SecondaryText>
                        </div>

                        <div className="access-detail">
                            <Notice
                                tone={refused ? 'warning' : 'error'}
                                message={describeError(error)}
                            />
                        </div>

                        <button
                            type="button"
                            className="bt-button bt-button--primary"
                            onClick={() => window.location.reload()}
                        >
                            Try again
                        </button>

                        <Typography.SecondaryText size="small">
                            {refused
                                ? 'Signing in with a work address usually fixes this. If it does not, ask a site admin to check the permitted email domain.'
                                : 'If this keeps happening it is worth reporting — the browser console has the detail.'}
                        </Typography.SecondaryText>
                    </div>
                </section>
            </div>
        </div>
    );
};
